"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = void 0;
const logger_js_1 = require("./logger/logger.js");
exports.logger = (0, logger_js_1.createClientLogger)("ts-http-runtime");
//# sourceMappingURL=log.js.map